import Text from '../components/Text';
import { createSignal } from "solid-js";
import { useNavigate } from "@solidjs/router";
import { useSFetch } from "../hooks/sfetch";
import { useToast } from '../components/MessageBox';
import { useTranslation } from '../hooks/useTranslation';
import TextWithCopyButton from '../components/TextWithCopyButton';
import CollapsePanel from '../components/CollapsPanel';

export default function VerifyAccount() {

    const toast = useToast();
    const sfetch = useSFetch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [ code, setCode ] = createSignal("");

    function submit(e: Event) {
        e.preventDefault();


        sfetch("/api/MinecraftAuth/useForRegistration", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                code: code(),
            }),
        }).then((response) => {
            if (response.ok) {
                toast?.info(t("VERIFYACCOUNT_VERIFIED"));
                navigate("/dashboard");
            }
            else {
                toast?.error(t("VERIFYACCOUNT_CODE_REJECTED"));
            }
        });
    }

    return (
        <div class='container' style={{ padding: "var(--spacing-4xl) var(--spacing-xl)" }}>
            <form onsubmit={submit}>
                <div class='v align-center'>
                    <h1><Text val="VERIFYACCOUNTHEADER"></Text></h1>
                    <p><Text val="VERIFYACCOUNTTEXT" /></p>
                    <div class='h align-center'>
                        <input
                            type="text"
                            placeholder={t("VERIFYSESSION_CODE_PLACEHOLDER")}
                            value={code()}
                            onInput={(e) => setCode((e.target as HTMLInputElement).value)}
                        />
                        <button type="submit" class="btn btn-primary"><Text val="SUBMIT" /></button>
                    </div>
                    <CollapsePanel header={t("VERIFYACCOUNT_INSTRUCTIONS")}>
                        <div class="v" style={{ padding: "var(--spacing-2xl)" }}>
                            <h2><Text val="STEP_1" />:</h2>
                            <span><Text val="STEP_1_INSTRUCTION" /></span>
                            <img src='/directconnect.png' style={{ "max-width": "100%", width: "30rem" }}></img>
                            <h2><Text val="STEP_2" />:</h2>
                            <span><Text val="STEP_2_INSTRUCTION" /></span>
                            <TextWithCopyButton text="panel.dsm-clan.de"></TextWithCopyButton>
                            <img src="/joinserver.png" style={{ "max-width": "100%", width: "30rem" }}></img>
                            <h2><Text val="STEP_3" />:</h2>
                            <span><Text val="STEP_3_INSTRUCTION" /></span>
                            <img src='/code.png' style={{ "max-width": "100%", width: "30rem" }}></img>
                        </div>
                    </CollapsePanel>
                </div>
            </form>
        </div>
    )
}